import { render, staticRenderFns } from "./RiskScenarioVulnerability.vue?vue&type=template&id=64a7c13b&scoped=true&"
import script from "./RiskScenarioVulnerability.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioVulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7c13b",
  null
  
)

export default component.exports